export default __webpack_public_path__ + "static/media/Google Chromebook Pixel.ce381b23.png";